<template lang="pug">
v-container
  v-card.pointer(v-for="item in activeMonth" :key="item.id" class="mx-auto mb-1" max-width="400" @click.native="goNext(item)")
    v-card-title {{ item.text }}
      span.ellipse.mg-agreement( v-if="notViewedMyAgreement && hasNewAgreement && notViewedMyAgreement.some(el => el.month == item.id)" )

</template>
<script>
import { mapState, mapActions } from "vuex";


export default {
  props: [ 'year'],
  data: () => ({
    months: [
      { id: 1, text: 'Январь' },
      { id: 2, text: 'Февраль' },
      { id: 3, text: 'Март' },
      { id: 4, text: 'Апрель' },
      { id: 5, text: 'Май' },
      { id: 6, text: 'Июнь' },
      { id: 7, text: 'Июль' },
      { id: 8, text: 'Август' },
      { id: 9, text: 'Сентябрь' },
      { id: 10, text: 'Октябрь' },
      { id: 11, text: 'Ноябрь' },
      { id: 12, text: 'Декабрь' },
    ],
  }),

  computed: {
    ...mapState("agreement", ['notViewedMyAgreement']),
    activeMonth() {
      let currentDay = new Date()
      let month = currentDay.getFullYear() <= this.year ? currentDay.getMonth() + 1 : 12
      if(currentDay.getFullYear() > this.year) {
        return this.months.filter(mon => mon.id >= month - 2 && mon.id <= month)
      }
      if(month == 1) {
        return this.months.filter(mon => mon.id == month)
      }
      if(month == 2) {
        return this.months.filter(mon => mon.id >= month - 1 && mon.id < month)
      }
      if(month == 3) {
        return this.months.filter(mon => mon.id >= month - 2 && mon.id < month)
      }

      return this.months.filter(mon => mon.id >= month - 3 && mon.id < month)
    },

    hasNewAgreement() {
      return this.notViewedMyAgreement && this.notViewedMyAgreement.length
    }
  },

  methods: {
    ...mapActions("agreement", ['loadMyAgreement']),
    goNext(item){
      this.loadMyAgreement({ month: item.id, year: this.year }).then(() => {
        this.$router.push(`/personalAccount/agreementYears/${this.year}/months/${item.id}/agreement`)
      })
    },
  }
}
</script>
<style scoped>
.ellipse {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: #ED0E51;
  position: relative;
  background-image: url(/src/layouts/img/red-circle.gif);
  background-size: cover;
}
.mg-agreement {
  margin-left: 5px;
  margin-bottom: 17px;
}
</style>